export default __webpack_public_path__ + "static/media/CORE_KSOP.0ed8e694.png";